import { DevicesAPI, IDeregisterRoomParams } from "../../services/hcnApi";

export const deregisterRoomUseCase = async (params: IDeregisterRoomParams) => {
  await DevicesAPI.deregisterRoom(params);
};
